import React, { Component } from "react";
import AppContextWrapper, { AppContext } from "@my-dld/contexts/AppContext";
import Popup from "@my-dld/components/Popup/Popup";
import { ConnectedRouter } from "connected-react-router";
import { history } from "@my-dld/reducers/store";
import { Route, RouteComponentProps } from "react-router";
import { JQModal } from "@my-dld/components/Popup/Utils";
import Strings, { LVStrings } from "@my-dld/assets/strings";

import { logout } from "@10x/sso";
import { AppConstants } from "../configApp";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { navigate } from "@my-dld/utils/StoreUtils";
import { LoginInfo as LF } from "../../typings/global";
import { LocaleUtil } from "@eres/core";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

interface Props extends RoutedViewProps {

}

interface State {

}

function showLogoutPopup() {
	JQModal( "logout-confirm" ).show();
}

class LogoutContainer extends Component<Props, State> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	rootUrl = AppConstants.rootUrlLocale;

	componentDidMount(): void {
		window.showMyDLDLogout = showLogoutPopup;
	}

	componentWillUnmount(): void {
		window.showMyDLDLogout = undefined;
	}

	render() {
		if ( this.context.user ) {
			return ( <>
					<UnverifiedEmailMessage/>
					<LoginHelp/>
					<div className="modal-logout">
						<Popup
							id={ "logout-confirm" }
							showCloseButton={ true }
							clickOutsideToDismiss={ false }
							showIcon={ false }
							noTitle={ false }>
							<div className="logout-icon"/>
							<p className="logout-text">
								{ Strings.confirm_logout }
							</p>
							<div>
								<button
									className="btn btn_1 btn-block mb-2" type="button"
									onClick={ this.logoutMe }>{ Strings.yes_logout }</button>
								<button
									className="btn btn-grey btn-block" type="button"
									onClick={ this.dismiss }>{ Strings.cancel }</button>
							</div>
						</Popup>
					</div>
				</>
			);
		}
		return <>
			<LoginHelp/>
		</>;
	}

	dismiss = () => {
		JQModal( "logout-confirm" ).hide();
	};
	logoutMe = () => {
		const isTabuUser = TabuProfile.getProfile() != null;
		const pathX = isTabuUser ? "/owner" : "/sso";

		JQModal( "logout-confirm" ).hide();
		this.redirectX( "logout" + pathX );
	};

	redirectX( path: string ) {
		if ( window.hasMyDLD ) {
			this.props.history.push( "/" + path );
		} else {
			window.location.href = this.rootUrl + "MyDLD/#/" + path;
		}
	}
}

export default class LogoutContainerX extends Component<Props> {
	render() {
		return <ConnectedRouter history={ history }>
			<AppContextWrapper>
				<Route
					render={ ( props: RouteComponentProps<any> ) => {
						return <LogoutContainer { ...{ ...this.props, ...props } }/>;
					} }>
				</Route>
			</AppContextWrapper>
		</ConnectedRouter>;
	}
}

function UnverifiedEmailMessage() {
	const onOky = () => {
		JQModal( "unverifiedEmail" ).hide( () => {
			navigate( "/mydld/profile" );
		} );
	};
	return <Popup
		id={ "unverifiedEmail" } showCloseButton={ true }
		footer={ <button
			type="button" className="btn btn_1 btn_style1"
			onClick={ onOky }>{ Strings.verify_email_address }
		</button> }>
		<p className={ "text-center" } style={ { whiteSpace: "pre-wrap" } }>
			{ Strings.verify_email_to_use_service }
		</p>
	</Popup>;
}

function LoginHelp() {
	const sso = window.AppInfo && window.AppInfo.loginInfo && window.AppInfo.loginInfo.sso;
	const owner = window.AppInfo && window.AppInfo.loginInfo && window.AppInfo.loginInfo.owner;
	return <div className="modal" tabIndex={ -1 } role="dialog" id="loginInfoDialog">
		<div className="modal-dialog modal-dialog-centered" role="document">
			<div className="modal-content">
				<div className="modal-header">
					<div className="modal-title"> { Strings.mnu_login_help } </div>
					<button
						type="button" className="close modal-close-svg-icon"
						data-bs-dismiss="modal" aria-label="Close"><span className="close-svg-icon"></span><span
						className="sr-only">Close</span></button>
				</div>
				<div className="modal-body">
					<L data={ sso } showDes={ true } key={ "sso" }/>
					<hr/>
					<L data={ owner } key={ "owner" }/>
				</div>
			</div>
		</div>
	</div>;
}

function L( props: { data: LF, showDes?: boolean } ) {
	const { data, showDes } = props;
	if ( !data ) return null;
	return <ul className="list-group sso-login-description-detail">
		<li
			key="title"
			className="list-group-item list-group-item-title">{ LocaleUtil.getLocalValue( LVStrings[ data.title ] ) }</li>
		{ data.items && data.items.map( it => {
			let localValue = LocaleUtil.getLocalValue( LVStrings[ it.title ] );
			return <React.Fragment key={ it.title }>
				{ !isEmptyStringOrNull( localValue ) &&
					<li
						key={ it.title }
						className="list-group-item">{ localValue }</li>
				}
				{ showDes && it.description.map( de => {
					let value = LocaleUtil.getLocalValue( LVStrings[ de ] );
					if ( !isEmptyStringOrNull( value ) )
						return <li
							key={ de }
							className="list-group-item">{ value }</li>;
					return null;
				} ) }
			</React.Fragment>;
		} ) }
	</ul>;
}
